module.exports = __webpack_public_path__ + "img/1509560038.c2eff28d.jpg";